import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { UtilsService } from 'src/app/shared/utils.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RBACService } from '../../../shared/rbac.service';

@Component({
  selector: 'app-notification-roles-tabs',
  templateUrl: './notification-roles-tabs.component.html',
  styleUrls: ['./notification-roles-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NotificationRolesTabsComponent implements OnInit {
  // Get a reference to the tabs container.
  @ViewChild('tabsContainer', { static: false }) tabsContainer: ElementRef;

  // The notification role id.
  notification_role_id: number;

  // RBAC permission flags. Resolved once in ngOnInit() so the template does not
  // re-evaluate permission checks on every change detection cycle.
  canManageSitesTab: boolean = false;
  canManageEmployeesTab: boolean = false;

  constructor(
    public utils: UtilsService,
    public rbac: RBACService,
    private dialogRef: MatDialogRef<NotificationRolesTabsComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: any
  ) {}

  protected readonly RBACService = RBACService;

  ngOnInit(): void {
    // Resolve RBAC permission flags.
    this.canManageSitesTab = this.rbac.userCanAccess(
      [
        RBACService.getPermission(
          RBACService.RBAC_F.F_ACCOUNT_NOTIFICATION_ROLES,
          RBACService.RBAC_A.A_EDIT
        ),
        RBACService.getPermission(
          RBACService.RBAC_F.F_SITES,
          RBACService.RBAC_A.A_VIEW
        )
      ],
      true
    );
    this.canManageEmployeesTab = this.rbac.userCanAccess(
      [
        RBACService.getPermission(
          RBACService.RBAC_F.F_ACCOUNT_NOTIFICATION_ROLES,
          RBACService.RBAC_A.A_EDIT
        ),
        RBACService.getPermission(
          RBACService.RBAC_F.F_EMPLOYEES,
          RBACService.RBAC_A.A_VIEW
        )
      ],
      true
    );

    // Get the notification role id.
    this.notification_role_id = Number(this.dialogData['notification_role_id']);
  }

  /**
   * Scrolls the tabs container to the top using a smooth behavior.
   *
   * @return {void}
   */
  onScrollToTop(): void {
    this.tabsContainer.nativeElement.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  /**
   * Close the dialog and respond with the notification role object.
   */
  onClose(): void {
    this.dialogRef.close();
  }
}
